import React from "react";

const ApiContext = React.createContext({
  languageData: "",
  changeLanguage: () => {},
});

export default ApiContext;
